import React, { useEffect, useState } from "react";
import DesignStyle from "./design.module.css";
import {
  Form,
  Input,
  Button,
  Upload,
  Col,
  Row,
  InputNumber,
  Table,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import http from "../../../utils/http";
const { TextArea } = Input;
const InputNumberStyle = {
  width: "95%",
};
function Design() {
  const [form] = Form.useForm();
  const [fileContent, setFileContent] = useState("");
  const [TableData, setTableData] = useState([]);
  const [colums, setColums] = useState([]);
  const [IsSubmitLoading, setIsSubmitLoading] = useState(false);
  const onFinish = (value) => {
    console.log(value);
    setIsSubmitLoading(true)
    const newFormData = new FormData();
    const TempleArr = {
      sequence: value.SN == undefined ? value.gene_id_text : value.SN.file,
      optimal_primer_size: value.optimal_primer_size,
      max_primer_size: value.max_primer_size,
      min_primer_size: value.min_primer_size,
      optimal_primer_tm: value.optimal_primer_tm,
      max_primer_tm: value.max_primer_tm,
      min_primer_tm: value.min_primer_tm,
      optimal_gc_percent: value.optimal_gc_percent,
      max_gc_percent: value.max_gc_percent,
      min_gc_percent: value.min_gc_percent,
      product_size_ranges: value.product_size_ranges,
    };
    Object.keys(TempleArr).forEach((key) => {
      newFormData.append(key, TempleArr[key]);
    });
    http
      .post("/api/tools/primer/", newFormData)
      .then((res) => {
        setTableData(res);
        console.log(res[0]);
        let columTempArr = [];
        Object.keys(res[0]).map((key) => {
          console.log(key.split("_").join(" "));
          columTempArr.push({
            key: key,
            title: key.split("_").join(" "),
            dataIndex: key,
            align: "center",
          });
        });
        setColums(columTempArr);
        setIsSubmitLoading(false)
      })
      .catch((err) => {
        setIsSubmitLoading(false)
      });
  };

  const contentUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const content = event.target.result;
      setFileContent(content);
      console.log(content);
    };
    reader.readAsText(file);
    return false; // 阻止默认上传行为
  };
  useEffect(() => {
    form.setFieldsValue({
      gene_id_text: fileContent,
    }); // 初始化时更新文本域的值
  }, [fileContent]);

  // 设置表格的行样式
  const rowClassName = (record, index) => {
    console.log(index);
    if (index === 0 || index === 1) {
      return { background: "red !important", fontWeight: "bold !important" };
    }
    return {};
  };

  return (
    <div className={DesignStyle.Design_app}>
      <div className={DesignStyle.Design_Header}>
        <p>Primer Design</p>
      </div>
      <p className={DesignStyle.Design_p}>
        This tool is intended for researchers to pick PCR-primers to amplify
        genomic regions avoiding to overlap with known SNPs/INDELs, using
        Primer3 as a backend engine.Please enter the primer design gene
        sequence.All the parameter can be changed if necessary.
      </p>
      <div className={DesignStyle.Design_Formdiv}>
        <Form
          form={form}
          onFinish={onFinish}
          style={{ margin: "10px 0" }}
          initialValues={{
            optimal_primer_size: 20,
            max_primer_size: 25,
            min_primer_size: 18,
            optimal_primer_tm: 59.0,
            max_primer_tm: 62.0,
            min_primer_tm: 57.0,
            optimal_gc_percent: 50.0,
            max_gc_percent: 80.0,
            min_gc_percent: 20.0,
            product_size_ranges: "100-1000",
          }}
        >
          <Form.Item name="gene_id_text">
            <TextArea style={{ height: 150 }} />
          </Form.Item>
          <Row>
            <Col span={6}>
              <Form.Item
                name="SN"
                style={{
                  width: "60%",
                }}
              >
                <Upload
                  beforeUpload={contentUpload}
                  name="SN"
                  action="/upload.do"
                  onRemove={() => {
                    setFileContent("");
                  }}
                >
                  <Button
                    style={{
                      border: "none",
                      padding: "0",
                      margin: "0",
                      background: "transparent",
                    }}
                    icon={<UploadOutlined />}
                  >
                    Click to upload
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
            <Col span={6}>
            <Form.Item>
              <Button
                style={{
                  color: "#67C23A",
                  border: "none",
                  fontWeight: "bold",
                   background: "transparent",
                  boxShadow:"none"
                }}
                onClick={()=>{
                  form.setFieldsValue({
                    gene_id_text:`>chr1
CCTTTCCAATCCCTCTTTCACAAATCTCTAAGGATGATGGTTCTCCCCATGAAGACCTTA
CTCTTTATTATCAACTAGTAGGCAACCTAATCTATCTCGCAATGACTCAATCGGATATAT
CATATGCAGTCCAACTTGTGAGCCAGTTTGTGTCTTCCCCAAGGCAACCACATCTATCTC
CAATCCATCGGATTATTAGGTATGTGTGTGTGGGGGGGACTTTATCAGATGGCATATTCT
TCTCCTCTTCATCCCTCATTAGCCTCACTACCTATGCGGATGCTGATTAGGTTGGATGCC
TTGACACCTGATGATCCATTATAGGTTGGTGTATATTGTTAGGTAACTCCCTTATTTCAT
GGAAGCGAAAGAAACAACCTATTGTGTCCAATTCTTCCACTGAAGCTGAATATAGAGCAA
TGCCCTTAGTGTGTAGTGAAATTATATGGCTCTGAGCTCTCCTACTTGACATCCTCAATG
AGACATCACCATTTGTTCCTCTCTATGCAGACATTGTGAGCGCAATCAAAATTTCTTCCA
ACCCCGTATTCCATGAGCGCACCAAACATATAGAAGTTAATTGCCACTTCATCTGCAATC
TACTTCTTAAGGGTACTATTTCTCTACCTTAGTGTCCTTTGGCCTCCAACTTGTAGACTT
GTTGACAAAGGCAATAACTTAGGCCTGGCATATATTTTTCATGGACAAACAGATGCTCAT
TCCTAGGAATCAGTTTGAGGGGGAGTGTAGAAACAAGGAAAACTAGCCAAAGGCCATTTT
TGTACTTTTACCTTTCTTTCTTGTACATTAACTTTTGTATACTATGGGTAGATTTGTCCT
TTTATGTTTCTTTAATATAAATATTATTTCTTTGGGTGTCGACTACCAATTTTGACACAC
CCAACAAACTGCTAGCTTCTCTCTCTCTCTCTCTCTCTCTCTCTCTTTGTCTATCCTTCT
TGATTTGATTCTAACACCAAGAAGCCTACGTAGTGGAAAAATGTCAGTGCATTGGTACTG
GAGCTACTCAAGGACCCTATACTCGACACAGAGATAAAAACCCATGACCTACCCAACCCC
TCATTCCTTTGGATGTAATAAGAGTGAGGTAATTTTAATAATGAACAAACTCATAGGAAA
TTGAGTGATTGAATTGCCCCCATCCCCTCCCCATGTAAACCCAAATAGGGACCATCAAGG
ACCAAGATGGTGTGATATCCACTAGGCCACCACACATGAGTTTACATGCTTTATATTGTG
AAGAATCTTCATGGCCAAGGAAAAATTGAAAGAGTACCTCCAATGCAAGCCAACAGAAGT
GAAAAGCAACCCCTACAACCATTGGTGAGGCGGAAGCATCAACATGGTAAGTGCAGTAAA
`,
                  })
                }}
              >example</Button>
            </Form.Item>
            </Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
          </Row>
          <Row>
            <Col span={8}>
              <Form.Item
                name="optimal_primer_size"
                label={
                  <span style={{ fontWeight: "bold" }}>
                    Optimal primer size
                  </span>
                }
              >
                <InputNumber
                  style={InputNumberStyle}
                  min={0}
                  // defaultValue={20}
                  onChange={(e) => {
                    console.log(e);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="max_primer_size"
                label={
                  <span style={{ fontWeight: "bold" }}>Max primer size</span>
                }
              >
                <InputNumber
                  style={InputNumberStyle}
                  min={0}
                  // defaultValue={25}
                  onChange={(e) => {
                    console.log(e);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="min_primer_size"
                label={
                  <span style={{ fontWeight: "bold" }}>Min primer size</span>
                }
              >
                <InputNumber
                  style={InputNumberStyle}
                  min={0}
                  // defaultValue={18}
                  onChange={(e) => {
                    console.log(e);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Form.Item
                label={
                  <span style={{ fontWeight: "bold" }}>Optimal primer TM</span>
                }
                name="optimal_primer_tm"
              >
                <InputNumber
                  style={InputNumberStyle}
                  min={0}
                  // defaultValue={59.0}
                  step={0.1}
                  onChange={(e) => {
                    console.log(e);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={
                  <span style={{ fontWeight: "bold" }}>Max primer TM</span>
                }
                name="max_primer_tm"
              >
                <InputNumber
                  style={InputNumberStyle}
                  min={0}
                  // defaultValue={62.0}
                  step={0.1}
                  onChange={(e) => {
                    console.log(e);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={
                  <span style={{ fontWeight: "bold" }}>Min primer TM</span>
                }
                name="min_primer_tm"
              >
                <InputNumber
                  style={InputNumberStyle}
                  min={0}
                  // defaultValue={57.0}
                  step={0.1}
                  onChange={(e) => {
                    console.log(e);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Form.Item
                label={
                  <span style={{ fontWeight: "bold" }}>Optimal GC percent</span>
                }
                name="optimal_gc_percent"
              >
                <InputNumber
                  style={InputNumberStyle}
                  min={0}
                  // defaultValue={50.0}
                  step={0.1}
                  onChange={(e) => {
                    console.log(e);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={
                  <span style={{ fontWeight: "bold" }}>Max GC percent</span>
                }
                name="max_gc_percent"
              >
                <InputNumber
                  style={InputNumberStyle}
                  min={0}
                  // defaultValue={80.0}
                  step={0.1}
                  onChange={(e) => {
                    console.log(e);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={
                  <span style={{ fontWeight: "bold" }}>Min GC percent</span>
                }
                name="min_gc_percent"
              >
                <InputNumber
                  style={InputNumberStyle}
                  min={0}
                  // defaultValue={20.0}
                  step={0.1}
                  onChange={(e) => {
                    console.log(e);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            label={
              <span style={{ fontWeight: "bold" }}>Product Size Ranges</span>
            }
            name="product_size_ranges"
          >
            <Input />
          </Form.Item>
          <Form.Item
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
            }}
          >
            <Button
              style={{
                margin: "0 10px",
                background: "#67C23A",
                border: "none",
                color: "white",
              }}
              htmlType="submit"
              loading={IsSubmitLoading}
            >
              Submit
            </Button>
            <Button
              style={{
                margin: "0 20px",
                border: "none",
                border: "1px solid #6C5E6E",
                color: "#6C5E6E",
              }}
              onClick={() => {
                form.resetFields();
                setFileContent("");
                setTableData([]);
              }}
            >
              Reset
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div
        className={DesignStyle.Design_content}
        style={{
          opacity: TableData.length > 0 ? 1 : 0, // 使用opacity控制显示隐藏
          transition: "opacity 0.3s ease-in-out", // 添加过渡效果
        }}
      >
        <Table
          style={{ width: "95%", margin: "10px auto" }}
          bordered
          columns={colums}
          dataSource={TableData}
          rowClassName={rowClassName} // 使用 rowClassName 动态设置行样式
        />
      </div>
    </div>
  );
}

export default Design;
